export const WSB_MERCHANT_SOURCE = 'onecom_wsb';

/* TODO: remove after full release of calendar v2
 * We will need to rename github repos from calendar-v2 to `calendar`
 * and from appointment-v4 to `appointment`
 * We will need to revert PR#1185 after full release.
 */
export const GRAVITY_CALENDAR_START_DATE = '2026-10-22';

/**
 * Sparse fields for boot/current merchant via merchantV2.find and
 * merchantV2.findAll (first-merchant fallback). Keep both call sites on this.
 */
export const CURRENT_MERCHANT_V2_FIELDS: Record<string, string[]> = {
  merchants: [
    'feature_toggles',
    'name',
    'organization',
    'created_at',
    'currency',
    'source',
    'ui_visibility',
    'category',
    'pixel_id',
    'slug',
    'phone',
    'time_zone',
    'address',
    'suspended',
    'suspension_reason',
  ],
  organizations: [
    'id',
    'trial_ends_on',
    'trial_days_left',
    'self_sign_up',
    'test',
    'package_code',
    'whitelabel_slug',
  ],
};

export const CURRENT_MERCHANT_V2_INCLUDE = ['organization'] as const;

export const GRAVITY_ACTIVATION_CLASS = 'gv-activated gv-h-full';

export const GRAVITY_DESIGN_APPS = [
  'ai-receptionist',
  'calendar-v2',
  'services-v2',
  'settings-v2',
  'settings-v3',
  'appointment-v3',
  'appointment-v4',
  'reminders-v2',
];

// Gravity version is pinned in `webpack.data.js`; brand choice lives in
// `../styles/gravity-brand.ts`.
